import { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';

class Header extends Component {
    state = { menuOpen: false, scrolled: false };

    componentDidMount() {
        this.onScroll = () => this.setState({ scrolled: window.scrollY > 50 });
        window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
    }

    toggleMenu = () => this.setState(prev => ({ menuOpen: !prev.menuOpen }));
    closeMenu  = () => this.setState({ menuOpen: false });

    render() {
        const { menuOpen, scrolled } = this.state;
        return (
            <>
                <header className={`site-header${scrolled ? ' scrolled' : ''}`}>
                    <div className="header-bar">
                        <div className="container-fluid">
                            <div className="row align-items-center">

                                {/* Logo */}
                                <div className="col-8 col-lg-3">
                                    <h1 className="site-branding">
                                        <Link to="/" onClick={this.closeMenu}>
                                            <span className="logo-kanji">桜</span>
                                            VIỆT NAM YOSAKOI
                                        </Link>
                                    </h1>
                                </div>

                                {/* Desktop nav */}
                                <div className="col-4 col-lg-9 d-flex justify-content-end align-items-center">
                                    <nav className="site-navigation d-none d-lg-flex">
                                        <ul>
                                            <li><NavLink exact to="/" activeClassName="active">Trang chủ</NavLink></li>
                                            <li><NavLink to="/about" activeClassName="active">Giới thiệu</NavLink></li>
                                            <li><NavLink to="/festival" activeClassName="active">Lễ hội</NavLink></li>
                                            <li><NavLink to="/schedule" activeClassName="active">Lịch diễn</NavLink></li>
                                            <li><NavLink to="/news" activeClassName="active">Tin tức</NavLink></li>
                                            <li><NavLink to="/teams" activeClassName="active">Yosakoi Team</NavLink></li>
                                            <li><NavLink to="/gallery" activeClassName="active">Gallery</NavLink></li>
                                            <li><NavLink to="/products" activeClassName="active">Gút-zự</NavLink></li>
                                            <li className="nav-cta"><NavLink to="/contact" activeClassName="active">Liên hệ</NavLink></li>
                                        </ul>
                                    </nav>

                                    {/* Mobile hamburger */}
                                    <button
                                        className={`hamburger-menu d-lg-none${menuOpen ? ' open' : ''}`}
                                        onClick={this.toggleMenu}
                                        aria-label="Toggle menu"
                                    >
                                        <span /><span /><span />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                {/* Mobile drawer — sibling of header, not child, to avoid fixed-in-fixed stacking context trap */}
                <div className={`mobile-drawer${menuOpen ? ' open' : ''}`} onClick={this.closeMenu}>
                    <nav className="mobile-nav" onClick={e => e.stopPropagation()}>
                        <button className="mobile-close" onClick={this.closeMenu}>✕</button>
                        <ul>
                            <li><NavLink exact to="/"        activeClassName="active" onClick={this.closeMenu}>Trang chủ</NavLink></li>
                            <li><NavLink to="/about"         activeClassName="active" onClick={this.closeMenu}>Giới thiệu</NavLink></li>
                            <li><NavLink to="/festival"      activeClassName="active" onClick={this.closeMenu}>Lễ hội</NavLink></li>
                            <li><NavLink to="/schedule"      activeClassName="active" onClick={this.closeMenu}>Lịch diễn</NavLink></li>
                            <li><NavLink to="/teams"         activeClassName="active" onClick={this.closeMenu}>Yosakoi Team</NavLink></li>
                            <li><NavLink to="/products"      activeClassName="active" onClick={this.closeMenu}>Gút-zự</NavLink></li>
                            <li><NavLink to="/gallery"       activeClassName="active" onClick={this.closeMenu}>Gallery</NavLink></li>
                            <li><NavLink to="/contact"       activeClassName="active" onClick={this.closeMenu}>Liên hệ</NavLink></li>
                        </ul>
                    </nav>
                </div>
            </>
        );
    }
}

export default Header;
